import ReactGA from 'react-ga'
import { getAnalyticsKey } from '../constants/analyticsKeys'


export function WtEvent(eventKey, actionObj) {
    // Google Analytics
    ReactGA.event({ 'category': getAnalyticsKey.nonLoggedInUser, 'action': eventKey, 'label': window.location.href })
    // End of Google Analytics
}
